module.exports = __webpack_public_path__ + "img/Mandarin.6751b5d4.png";